import { render, staticRenderFns } from "./TransferPaymentMethod.vue?vue&type=template&id=518b80a0&"
import script from "./TransferPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./TransferPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./TransferPaymentMethod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports